var _defs, _g, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_79_02427"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_79_02427)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.26650390625,3.33349609375C7.8662839062500005,3.33349609375,7.43962090625,3.50016309375,7.14650390625,3.83349609375C6.85295390625,4.16682909375,6.66650390625,4.5837160937500006,6.66650390625,5.00016609375L6.66650390625,35.00019609375C6.66650390625,35.41699609375,6.82650390625,35.86149609375,7.14650390625,36.16679609375C7.46650390625,36.50019609375,7.86672390625,36.66679609375,8.26650390625,36.66679609375L31.73320390625,36.66679609375C32.13330390625,36.66679609375,32.56000390625,36.50019609375,32.85320390625,36.16679609375C33.173203906249995,35.83349609375,33.33320390625,35.41669609375,33.33320390625,35.00019609375L33.33320390625,12.50016609375L24.16650390625,3.33349609375L8.26650390625,3.33349609375Z",
    fill: "#26BD4B",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.332929765624996,12.50016609375L25.887259765625,12.50016609375C25.456759765625,12.50016609375,24.997760765625,12.32917609375,24.682426765625,11.98721609375C24.338259765625,11.67351609375,24.166259765625,11.21754609375,24.166259765625,10.79031609375L24.166259765625,3.33349609375L33.332929765624996,12.50016609375Z",
    fill: "#EDFCEF",
    fillOpacity: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.99782609375,20.43382609375L23.08332609375,15.83349609375L24.66682609375,15.83349609375L20.78799609375,21.610666093749998L24.66682609375,27.387796093749998L23.08332609375,27.387796093749998L19.99782609375,22.78766609375L16.90916609375,27.387796093749998L15.33349609375,27.387796093749998L19.20832609375,21.610666093749998L15.33349609375,15.83349609375L16.90916609375,15.83349609375L19.99782609375,20.43382609375Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcel);
export default __webpack_public_path__ + "static/media/icon_excel.6fcb61677d42763fe16e3cbd7b6f58a0.svg";
export { ForwardRef as ReactComponent };